import React from "react"

const Quote = props => {
  return (
    <div className="Kudos-quoteWrapper">
      <p className="Kudos-quote">{props.quote}</p>
      <p className="Kudos-author">
        -{" "}
        {props.authorLink && (
          <a href={props.authorLink} target="_blank" rel="noopener noreferrer">
            {props.author}
            <br />
            {props.author2}
          </a>
        )}
        {props.link && (
          <a href={props.link} target="_blank" rel="noopener noreferrer">
            {props.author}
            <br />
            {props.author2}
          </a>
        )}
      </p>
    </div>
  )
}

export default Quote
